import React, { useState, useMemo } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Collapse,
  IconButton,
  Box,
  Typography,
  Paper,
} from '@material-ui/core';
import { ExpandMore, ExpandLess } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import { cancelAppointment } from './legalActions';
import { connect } from 'react-redux';

const statusColors = {
  Cancelar: { label: 'Cancelar', color: '#f28b82' },
  'Não compareceu': { label: 'Não compareceu', color: '#c18401' },
  Concluído: { label: 'Concluído', color: '#34a853' },
  Cancelado: { label: 'Cancelado', color: '#5f6368' },
};

const useStatusButtonStyles = makeStyles({
  button: (props) => ({
    backgroundColor: props.color || '#ccc',
    color: '#fff',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: props.color || '#aaa',
    },
  }),
});

const StatusButton = ({ status }) => {
  const statusData = statusColors[status?.trim()] || {};
  const classes = useStatusButtonStyles({ color: statusData.color });

  return (
    <Button variant="contained" size="small" className={classes.button}>
      {statusData.label || status}
    </Button>
  );
};

const formatDate = (timestamp) => {
  const date = new Date(timestamp);
  return date.toLocaleDateString();
};

const formatTime = (timestamp) => {
  const date = new Date(timestamp);
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};

const canCancel = (dataTimestamp) => {
  const now = new Date().getTime();
  const diff = dataTimestamp - now;
  return diff > 48 * 60 * 60 * 1000;
};

const LegalAppointmentsCard = (props) => {
  const { data, cancelAppointment, loading } = props;
  const [open, setOpen] = useState(false);

  const appointmentsList = useMemo(() => {
    return data.map((item) => {
      const dataTimestamp = Number(item.data) || 0;
      const horaInicioTimestamp = Number(item.horaInicio) || dataTimestamp;
      const isPast = dataTimestamp < new Date().getTime();

      let status = item.situacao;
      if (item.conclusao && item.conclusao.isFiliadoAusente) {
        status = 'Não compareceu';
      }
      return {
        type: isPast ? 'history' : 'upcoming',
        name: item.escritorio?.nome || '',
        date: formatDate(dataTimestamp),
        time: formatTime(horaInicioTimestamp),
        status,
        dataTimestamp,
        id: item.id,
        escritorioId: item.escritorio.id,
      };
    });
  }, [data]);

  const upcoming = appointmentsList.filter((a) => a.type === 'upcoming');
  const history = appointmentsList.filter((a) => a.type === 'history');

  const handleCancel = (row) => {
    const appointmentId = row?.id;
    const escritorioId = row?.escritorioId;
    cancelAppointment(escritorioId, appointmentId);
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  };

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Agendamentos</TableCell>
            <TableCell>Data</TableCell>
            <TableCell>Horário</TableCell>
            <TableCell>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {upcoming.map((row, idx) => (
            <TableRow key={`upcoming-${idx}`}>
              <TableCell>{row.name?.toUpperCase()}</TableCell>
              <TableCell>{row.date}</TableCell>
              <TableCell>{row.time}</TableCell>
              <TableCell>
                {canCancel(row.dataTimestamp) && row.status !== 'Cancelado' ? (
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    onClick={() => handleCancel(row)}
                  >
                    {loading ? 'Cancelando...' : 'Cancelar'}
                  </Button>
                ) : (
                  <StatusButton status={row.status} />
                )}
              </TableCell>
            </TableRow>
          ))}

          <TableRow>
            <TableCell colSpan={4}>
              <Box
                display="flex"
                alignItems="center"
                onClick={() => setOpen(!open)}
                style={{ cursor: 'pointer' }}
              >
                <Typography variant="body1">
                  Histórico de atendimentos
                </Typography>
                <IconButton size="small">
                  {open ? <ExpandLess /> : <ExpandMore />}
                </IconButton>
              </Box>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell colSpan={4} style={{ paddingBottom: 0, paddingTop: 0 }}>
              <Collapse in={open} timeout="auto" unmountOnExit>
                <Box margin={1}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Agendamentos</TableCell>
                        <TableCell>Data</TableCell>
                        <TableCell>Horário</TableCell>
                        <TableCell>Status</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {history.map((row, idx) => (
                        <TableRow key={`history-${idx}`}>
                          <TableCell>{row.name?.toUpperCase()}</TableCell>
                          <TableCell>{row.date}</TableCell>
                          <TableCell>{row.time}</TableCell>
                          <TableCell>
                            <StatusButton status={row.status} />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Box>
              </Collapse>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.legal.cancelAppointmentsLoading,
  };
};

const mapDispatchToProps = {
  cancelAppointment,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LegalAppointmentsCard);
